import {
  Container,
  Grid,
  Button,
  Grow,
  Typography,
  useTheme,
  Box,
  Slide,
  Fade,
  makeStyles,
  ButtonBase
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { HeroParticles } from "../../components/shared/HeroParticles";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 100%)",
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },
  nounderline: {
    "&:hover": { textDecoration: "none" },
    width: "100%",
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionWhite: {
    padding: "40px 0",
    background: "#ffffff",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  serviceCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    width: "100%",
    height: 280,
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      height: 230,
      borderRadius: 16,
    },
    [theme.breakpoints.down('xs')]: {
      height: 200,
    },
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 50px rgba(76, 0, 76, 0.2)",
    },
    "&:hover $serviceImg": {
      transform: "scale(1.08)",
      filter: "brightness(0.85)",
    },
    "&:hover $serviceGlass": {
      backdropFilter: "blur(18px)",
      background: "rgba(76, 0, 76, 0.8)",
    },
    "&:hover $serviceAccent": {
      width: "40px",
    },
  },
  serviceImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    border: "none",
    transition: "all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)",
  },
  serviceGlass: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(76, 0, 76, 0.6)",
    backdropFilter: "blur(12px)",
    padding: "16px 18px",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    [theme.breakpoints.down('sm')]: {
      padding: "14px 16px",
    },
  },
  serviceAccent: {
    width: "24px",
    height: "2px",
    background: "rgba(255,255,255,0.6)",
    borderRadius: 2,
    marginBottom: 8,
    transition: "width 0.4s ease",
  },
  serviceTitle: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#ffffff",
    marginBottom: 6,
    lineHeight: 1.3,
    letterSpacing: "0.2px",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.78rem",
    },
  },
  serviceDesc: {
    fontSize: "0.72rem",
    color: "rgba(255,255,255,0.8)",
    lineHeight: 1.5,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  techSection: {
    padding: "48px 0 44px",
    background: "linear-gradient(160deg, #4c004c 0%, #3a003a 40%, #2d002d 100%)",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "radial-gradient(circle at 50% 0%, rgba(155,59,155,0.15) 0%, transparent 60%)",
      pointerEvents: "none",
    },
  },
  techTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#ffffff",
    textAlign: "center",
    marginBottom: 4,
    position: "relative",
    zIndex: 1,
  },
  techSubtitle: {
    fontSize: "0.78rem",
    color: "rgba(255,255,255,0.45)",
    textAlign: "center",
    marginBottom: 28,
    position: "relative",
    zIndex: 1,
  },
  techMarquee: {
    display: "flex",
    overflow: "hidden",
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 80,
      zIndex: 2,
    },
    "&::before": {
      left: 0,
      background: "linear-gradient(90deg, #4c004c, transparent)",
    },
    "&::after": {
      right: 0,
      background: "linear-gradient(270deg, #2d002d, transparent)",
    },
  },
  techTrack: {
    display: "flex",
    gap: 16,
    animation: "$techScroll 40s linear infinite",
    "&:hover": {
      animationPlayState: "paused",
    },
    [theme.breakpoints.down('sm')]: {
      gap: 12,
    },
  },
  techTrackReverse: {
    display: "flex",
    gap: 16,
    animation: "$techScrollReverse 35s linear infinite",
    marginTop: 16,
    "&:hover": {
      animationPlayState: "paused",
    },
    [theme.breakpoints.down('sm')]: {
      gap: 12,
      marginTop: 12,
    },
  },
  "@keyframes techScroll": {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-50%)" },
  },
  "@keyframes techScrollReverse": {
    "0%": { transform: "translateX(-50%)" },
    "100%": { transform: "translateX(0)" },
  },
  techCard: {
    minWidth: 90,
    height: 70,
    borderRadius: 14,
    background: "rgba(255,255,255,0.95)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 14px",
    transition: "all 0.3s ease",
    cursor: "default",
    flexShrink: 0,
    gap: 4,
    "&:hover": {
      background: "#ffffff",
      boxShadow: "0 8px 28px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-3px)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 75,
      height: 60,
      borderRadius: 10,
      padding: "8px 10px",
    },
  },
  techLogo: {
    height: 32,
    objectFit: "contain",
    border: "none !important",
    [theme.breakpoints.down('sm')]: {
      height: 26,
    },
  },
  techName: {
    fontSize: "0.55rem",
    fontWeight: 600,
    color: "#555",
    textAlign: "center",
    lineHeight: 1.1,
    letterSpacing: "0.3px",
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));

export const Services = () => {
  const theme = useTheme();

  const classes = useStyles();

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  const [services, setServices] = useState();
  //const [checked, setChecked] =  useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 2);
    Axios.get("/api/getservices", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setServices(res.data.data);
      }
    });
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
  };

  
  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>
      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <HeroParticles id="services-hero-particles" />
        <Box className={classes.heroContent}>
          <Typography className={classes.heroTitle}>
            Our Services
          </Typography>
          <Box className={classes.heroDivider} />
          <Typography className={classes.heroSubtitle}>
            Elevate Your Business with Our Comprehensive IT Solutions
          </Typography>
        </Box>
      </Box>

      {isloading ? (
        <Loading />
      ) : (
        <>
        <Box className={classes.section}>
          <Container maxWidth="lg">
            <Slide direction="up" in={true} timeout={800}>
              <Box>
                <Typography className={classes.sectionTitle}>
                  Solutions Crafted for Success
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Explore the breadth of our expertise and customized IT services
                </Typography>
              </Box>
            </Slide>
            {services && (
              <Grid container spacing={3}>
                {services.map((service, index) => {
                  let serv_dec = parse(service.serv_desc.substring(0, 120) + "...");
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Grow in={true} timeout={600 + index * 100}>
                        <ButtonBase
                          className={classes.nounderline}
                          component={Link}
                          to={
                            "/service-details/" +
                            service.serv_name.split(" ").join("-") +
                            "/" +
                            service.serv_id
                          }
                        >
                          <Box className={classes.serviceCard}>
                            <img
                              src={"/static/services/" + service.serv_image}
                              alt={service.serv_name}
                              className={classes.serviceImg}
                            />
                            <Box className={classes.serviceGlass}>
                              <Box className={classes.serviceAccent} />
                              <Typography className={classes.serviceTitle}>
                                {service.serv_name}
                              </Typography>
                              <Typography className={classes.serviceDesc}>
                                {serv_dec}
                              </Typography>
                            </Box>
                          </Box>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Container>
        </Box>

        {/* Technologies Section - Marquee */}
        <Box className={classes.techSection}>
          <Typography className={classes.techTitle}>
            Technologies We Use
          </Typography>
          <Typography className={classes.techSubtitle}>
            Cutting-edge tools and platforms powering our solutions
          </Typography>

          {/* Row 1 - scrolls left */}
          <Box className={classes.techMarquee}>
            <Box className={classes.techTrack}>
              {[...[ 
                { name: "NodeJs", src: "nodejs.png" },
                { name: "Python", src: "python.png" },
                { name: "Dart", src: "dart.png" },
                { name: "ReactJs", src: "react.png" },
                { name: "C#", src: "c-sharp.png" },
                { name: "PHP", src: "php.png" },
                { name: "ExpressJs", src: "express.png" },
                { name: "Flask", src: "flask.png" },
                { name: "Pyteal", src: "pyteal.png" },
                { name: "Solidity", src: "solidity.png" },
                { name: "Flutter", src: "flutter.png" },
                { name: "Django", src: "django.png" },
              ], ...[ 
                { name: "NodeJs", src: "nodejs.png" },
                { name: "Python", src: "python.png" },
                { name: "Dart", src: "dart.png" },
                { name: "ReactJs", src: "react.png" },
                { name: "C#", src: "c-sharp.png" },
                { name: "PHP", src: "php.png" },
                { name: "ExpressJs", src: "express.png" },
                { name: "Flask", src: "flask.png" },
                { name: "Pyteal", src: "pyteal.png" },
                { name: "Solidity", src: "solidity.png" },
                { name: "Flutter", src: "flutter.png" },
                { name: "Django", src: "django.png" },
              ]].map((tech, i) => (
                <Box className={classes.techCard} key={i}>
                  <img
                    alt={tech.name}
                    src={`/static/techs/${tech.src}`}
                    className={classes.techLogo}
                  />
                  <Typography className={classes.techName}>{tech.name}</Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Row 2 - scrolls right */}
          <Box className={classes.techMarquee}>
            <Box className={classes.techTrackReverse}>
              {[...[
                { name: "CodeIgniter", src: "codeigniter.png" },
                { name: "Xcode", src: "xcode.png" },
                { name: "Android Studio", src: "androidstudio.png" },
                { name: "Unity", src: "unity.png" },
                { name: "JavaScript", src: "javascript.png" },
                { name: "jQuery", src: "jquery.png" },
                { name: "HTML", src: "html.png" },
                { name: "CSS", src: "css.png" },
                { name: "Bootstrap", src: "bootstrap.png" },
                { name: "MongoDB", src: "mongodb.png" },
                { name: "MySQL", src: "mysql.png" },
                { name: "Firebase", src: "firebase.png" },
              ], ...[
                { name: "CodeIgniter", src: "codeigniter.png" },
                { name: "Xcode", src: "xcode.png" },
                { name: "Android Studio", src: "androidstudio.png" },
                { name: "Unity", src: "unity.png" },
                { name: "JavaScript", src: "javascript.png" },
                { name: "jQuery", src: "jquery.png" },
                { name: "HTML", src: "html.png" },
                { name: "CSS", src: "css.png" },
                { name: "Bootstrap", src: "bootstrap.png" },
                { name: "MongoDB", src: "mongodb.png" },
                { name: "MySQL", src: "mysql.png" },
                { name: "Firebase", src: "firebase.png" },
              ]].map((tech, i) => (
                <Box className={classes.techCard} key={i}>
                  <img
                    alt={tech.name}
                    src={`/static/techs/${tech.src}`}
                    className={classes.techLogo}
                  />
                  <Typography className={classes.techName}>{tech.name}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Quote Section */}
        <Box className={classes.sectionWhite}>
          <Container maxWidth="lg">
            <Fade in={true} timeout={1200}>
              <Box className={classes.quoteSection}>
                <TypingQuote
                  text={`"As Managing Director and Architect of ESAY and AraFaceFinder, I witness firsthand the Arawinz team's blend of innovation and dedication. We're committed to excellence and shaping a smarter, more connected future."`}
                  className={classes.quoteText}
                />
                <Typography className={classes.quoteAuthor}>
                  - Chethan. P. S. S, Managing Director
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>
        </>
      )}
      
    </div>
  );
};

